import { AddressSchema } from "./Address";
import { InferType, number, object, string } from "yup";

export type RegistrarAccount = InferType<typeof RegistrarAccountSchema>;

export const RegistrarAccountSchema = object({
    id: number().required(),
    firstName: string().required("error.registrarAccount.firstName.required"),
    lastName: string().required("error.registrarAccount.lastName.required"),
    email: string().email().required("error.registrarAccount.email.required"),
    phoneNumber: string().required("error.registrarAccount.phoneNumber.required"),
    registrar: string().required("error.registrarAccount.registrar.required"),
    login: string().required("error.registrarAccount.login.required"),
    password: string().required("error.registrarAccount.password.required"),
    apiKey: string().required("error.registrarAccount.apiKey.required"),
    apiSecret: string().optional(),
    address: AddressSchema.notRequired(),
    maxSitesPerThematic: number().required("error.registrarAccount.maxSitesPerThematic.required"),
});

export const UpsertRegistrarDTOSchema = RegistrarAccountSchema.omit(["id"]);
